
































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class Registration extends ViewBase {
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: String, default: '' }) btnyes!: string
  svisible = false
  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
  }
  onOk() {
    this.$emit('onOk')
  }
  onCancel() {
    this.$emit('onOk')
  }
}
